module.exports = __webpack_public_path__ + "media/images/icon/arrow-circle-right-red-f99f217527df103634b5c6e77516d1be.svg";